import CssBaseline from "@mui/material/CssBaseline";
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import "../../misc/polyfills";

import createCftheme from "../../../theme";
import { Metadata } from "../../components/common/Metadata/Metadata";
import { getAppVariant } from "../../variants/getAppVariant";
import { SnackbarProvider } from "../SnackbarProvider/SnackbarProvider";

const BaseContainer = ({ children }: React.PropsWithChildren<unknown>) => {
  const variant = getAppVariant();
  const muiTheme = createTheme(createCftheme(variant));

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={muiTheme}>
        <CssBaseline />
        <Metadata />
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <SnackbarProvider>{children}</SnackbarProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export { BaseContainer };
